import { ReactNode } from 'react'

import { ChevronDown } from 'lucide-react'

import { Button } from '~/components/component-library'
import { cn } from '~/utils/tailwind-utils'

export const ShowMoreToggle = ({
  isExpanded,
  onToggle,
  expandedLabel,
  collapsedLabel,
}: {
  isExpanded: boolean
  onToggle: () => void
  expandedLabel: ReactNode
  collapsedLabel: ReactNode
}) => (
  <Button
    type="button"
    variant="tertiary"
    size="small"
    onClick={onToggle}
    suffix={
      <ChevronDown
        className={cn('transition-transform', { 'rotate-180': isExpanded })}
      />
    }
  >
    {isExpanded ? expandedLabel : collapsedLabel}
  </Button>
)
